// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: puuCzCTMd1
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: Z-JBWeJQzP-/component
import Switch from "../../Switch"; // plasmic-import: fZHRV-Xq5mi/component
import Button from "../../Button"; // plasmic-import: aLOScdJViiG/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicProjectSettings.module.css"; // plasmic-import: puuCzCTMd1/css

import XSvgrepoComsvgIcon from "./icons/PlasmicIcon__XSvgrepoComsvg"; // plasmic-import: bhCqgTTbQ_/icon
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: 074BTgmJsHD/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YgxDZcg-ug-/icon
import CopySvgrepoComsvgIcon from "./icons/PlasmicIcon__CopySvgrepoComsvg"; // plasmic-import: TaK1a7VmsO/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: tWUxgGBbs9p/icon

export type PlasmicProjectSettings__VariantMembers = {
  state: "notionEnabled";
};

export type PlasmicProjectSettings__VariantsArgs = {
  state?: MultiChoiceArg<"notionEnabled">;
};

type VariantPropType = keyof PlasmicProjectSettings__VariantsArgs;
export const PlasmicProjectSettings__VariantProps = new Array<VariantPropType>(
  "state"
);

export type PlasmicProjectSettings__ArgsType = {};
type ArgPropType = keyof PlasmicProjectSettings__ArgsType;
export const PlasmicProjectSettings__ArgProps = new Array<ArgPropType>();

export type PlasmicProjectSettings__OverridesType = {
  root?: p.Flex<"div">;
  closeHandle?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
  projectLink?: p.Flex<typeof TextInput>;
  copyProjectLink?: p.Flex<"svg">;
  notionHandle?: p.Flex<"div">;
  notionSwitch?: p.Flex<typeof Switch>;
  notionKey?: p.Flex<typeof TextInput>;
  databaseId?: p.Flex<typeof TextInput>;
  googleSignIn?: p.Flex<typeof Button>;
};

export interface DefaultProjectSettingsProps {
  state?: MultiChoiceArg<"notionEnabled">;
  className?: string;
}

function PlasmicProjectSettings__RenderFunc(props: {
  variants: PlasmicProjectSettings__VariantsArgs;
  args: PlasmicProjectSettings__ArgsType;
  overrides: PlasmicProjectSettings__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__fL21)}>
        <div className={classNames(projectcss.all, sty.freeBox__wkK9)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__xU7Ur
            )}
          >
            {"Einstellungen"}
          </div>

          <p.Stack
            as={"div"}
            data-plasmic-name={"closeHandle"}
            data-plasmic-override={overrides.closeHandle}
            hasGap={true}
            className={classNames(projectcss.all, sty.closeHandle)}
          >
            <XSvgrepoComsvgIcon
              data-plasmic-name={"svg"}
              data-plasmic-override={overrides.svg}
              className={classNames(projectcss.all, sty.svg)}
              role={"img"}
            />
          </p.Stack>
        </div>

        <div className={classNames(projectcss.all, sty.freeBox__ejvie)}>
          <div className={classNames(projectcss.all, sty.freeBox__jv4Mz)}>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__xa7Gy)}
            >
              <TextInput
                data-plasmic-name={"projectLink"}
                data-plasmic-override={overrides.projectLink}
                className={classNames("__wab_instance", sty.projectLink)}
                isDisabled={true}
                required={false}
              />

              <CopySvgrepoComsvgIcon
                data-plasmic-name={"copyProjectLink"}
                data-plasmic-override={overrides.copyProjectLink}
                className={classNames(projectcss.all, sty.copyProjectLink)}
                role={"img"}
              />
            </p.Stack>
          </div>

          <div
            className={classNames(projectcss.all, sty.freeBox__b0EfR, {
              [sty.freeBoxstate_notionEnabled__b0EfRdQNsa]: hasVariant(
                variants,
                "state",
                "notionEnabled"
              )
            })}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"notionHandle"}
              data-plasmic-override={overrides.notionHandle}
              hasGap={true}
              className={classNames(projectcss.all, sty.notionHandle, {
                [sty.notionHandlestate_notionEnabled]: hasVariant(
                  variants,
                  "state",
                  "notionEnabled"
                )
              })}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__lkukj
                )}
              >
                {"Notion Integration"}
              </div>

              <Switch
                data-plasmic-name={"notionSwitch"}
                data-plasmic-override={overrides.notionSwitch}
                className={classNames("__wab_instance", sty.notionSwitch, {
                  [sty.notionSwitchstate_notionEnabled]: hasVariant(
                    variants,
                    "state",
                    "notionEnabled"
                  )
                })}
              >
                {"\n"}
              </Switch>
            </p.Stack>

            {(hasVariant(variants, "state", "notionEnabled") ? true : true) ? (
              <div
                className={classNames(projectcss.all, sty.freeBox__av9Gt, {
                  [sty.freeBoxstate_notionEnabled__av9GtdQNsa]: hasVariant(
                    variants,
                    "state",
                    "notionEnabled"
                  )
                })}
              >
                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox___6Hss)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___2SJbe
                    )}
                  >
                    {"Notion Key"}
                  </div>

                  <TextInput
                    data-plasmic-name={"notionKey"}
                    data-plasmic-override={overrides.notionKey}
                    className={classNames("__wab_instance", sty.notionKey)}
                    required={false}
                  />
                </p.Stack>

                <p.Stack
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__fxEnY)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__myB7O
                    )}
                  >
                    {"Database ID"}
                  </div>

                  <TextInput
                    data-plasmic-name={"databaseId"}
                    data-plasmic-override={overrides.databaseId}
                    className={classNames("__wab_instance", sty.databaseId)}
                    required={false}
                  />
                </p.Stack>
              </div>
            ) : null}
          </div>

          {true ? (
            <Button
              data-plasmic-name={"googleSignIn"}
              data-plasmic-override={overrides.googleSignIn}
              className={classNames("__wab_instance", sty.googleSignIn)}
            >
              {"Sign-In with Google"}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "closeHandle",
    "svg",
    "projectLink",
    "copyProjectLink",
    "notionHandle",
    "notionSwitch",
    "notionKey",
    "databaseId",
    "googleSignIn"
  ],
  closeHandle: ["closeHandle", "svg"],
  svg: ["svg"],
  projectLink: ["projectLink"],
  copyProjectLink: ["copyProjectLink"],
  notionHandle: ["notionHandle", "notionSwitch"],
  notionSwitch: ["notionSwitch"],
  notionKey: ["notionKey"],
  databaseId: ["databaseId"],
  googleSignIn: ["googleSignIn"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  closeHandle: "div";
  svg: "svg";
  projectLink: typeof TextInput;
  copyProjectLink: "svg";
  notionHandle: "div";
  notionSwitch: typeof Switch;
  notionKey: typeof TextInput;
  databaseId: typeof TextInput;
  googleSignIn: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProjectSettings__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProjectSettings__VariantsArgs;
    args?: PlasmicProjectSettings__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicProjectSettings__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicProjectSettings__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicProjectSettings__ArgProps,
          internalVariantPropNames: PlasmicProjectSettings__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicProjectSettings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProjectSettings";
  } else {
    func.displayName = `PlasmicProjectSettings.${nodeName}`;
  }
  return func;
}

export const PlasmicProjectSettings = Object.assign(
  // Top-level PlasmicProjectSettings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeHandle: makeNodeComponent("closeHandle"),
    svg: makeNodeComponent("svg"),
    projectLink: makeNodeComponent("projectLink"),
    copyProjectLink: makeNodeComponent("copyProjectLink"),
    notionHandle: makeNodeComponent("notionHandle"),
    notionSwitch: makeNodeComponent("notionSwitch"),
    notionKey: makeNodeComponent("notionKey"),
    databaseId: makeNodeComponent("databaseId"),
    googleSignIn: makeNodeComponent("googleSignIn"),

    // Metadata about props expected for PlasmicProjectSettings
    internalVariantProps: PlasmicProjectSettings__VariantProps,
    internalArgProps: PlasmicProjectSettings__ArgProps
  }
);

export default PlasmicProjectSettings;
/* prettier-ignore-end */
